import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

import { useMediaQuery } from '../../hooks/useMediaQuery'
import PAGES from '../../enums/pages'
import { NavUser } from '../NavUser'
import { SidebarProvider } from '../ui/sidebar'
import { cn } from '@/lib/utils'

const Sidebar = ({
    display,
    activePage,
    setActivePage,
    close,
    bannerHeight,
    isBannerEnabled,
}) => {
    const isTablet = useMediaQuery('(min-width: 768px)')
    const [isClicked, setIsClicked] = useState(false)

    const location = useLocation()

    useEffect(() => {
        if (
            location.pathname.includes(
                import.meta.env.VITE_LIVEBOOKS_V2_REDIRECTION === 'true'
                    ? '/livebooks-legacy'
                    : '/livebooks'
            )
        ) {
            setActivePage(PAGES.LIVEBOOKS.slug)
        } else if (location.pathname.includes('/dojo')) {
            setActivePage(PAGES.DOJO.slug)
        } else {
            setActivePage(PAGES.HOME.slug)
        }
    }, [location, setActivePage])

    const isVisible = display?.base === 'flex' || isTablet
    const sidebarLeft = !isTablet ? (isVisible ? '0' : '-260px') : '0'
    // Ensure sidebar is pushed below banner when bannerHeight is set
    const sidebarTop =
        bannerHeight && bannerHeight > 0 ? `${bannerHeight}px` : '0'
    const sidebarHeight =
        bannerHeight && bannerHeight > 0
            ? `calc(100vh - ${bannerHeight}px)`
            : '100vh'

    return (
        <SidebarProvider defaultOpen={isTablet}>
            <div
                className={cn(
                    'bg-white dark:bg-gray-900 border-r-[3px] border-r-[#333333] dark:border-r-gray-700 w-[260px] md:w-16 fixed flex flex-col z-[1] transition-[left,top,height] duration-300 ease-in-out pt-24 md:pt-16'
                )}
                style={{
                    left: sidebarLeft,
                    top: sidebarTop,
                    height: sidebarHeight,
                }}
            >
                <div className="flex items-center justify-center w-full pt-4 md:pt-0 flex-shrink-0">
                    <Link
                        to="/"
                        onClick={() => {
                            close()
                        }}
                        onMouseUp={() => setIsClicked(false)}
                        onMouseDown={() => setIsClicked(true)}
                        onMouseLeave={() => setIsClicked(false)}
                        className="flex items-center justify-center w-8 h-8"
                    >
                        {isClicked ? (
                            <img
                                src="/images/sidebar-2d-logo.svg"
                                alt="Logo"
                                className="w-full h-auto"
                            />
                        ) : (
                            <img
                                src="/images/sidebar-3d-logo.svg"
                                alt="Logo"
                                className="w-full h-auto"
                            />
                        )}
                    </Link>
                </div>
                {/* Spacer to push NavUser to bottom */}
                <div className="flex-grow" />
                {/* NavUser component - positioned at bottom */}
                <div className="w-full px-2 pb-[30px] md:pb-4 flex-shrink-0">
                    <NavUser />
                </div>
            </div>
        </SidebarProvider>
    )
}

export default Sidebar
